import workspaceQuery from 'graphql/queries/product/MinMaxCalculationResultDetailsWorkspaceQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const MinMaxCalculationResultDetails: EntityType = {
  type: 'MinMaxCalculationResult',
  title: 'Min/Max Calculation Results',
  formTitle: 'Min/Max Calculation Result',
  formUrl: '/Products/MinMaxLevels/',
  workspaceUrl: '/Products/MinMaxCalculationResultDetails/Workspace/',
  workspace: workspaceQuery,
  screenReference: 'PRODUCTS_MINMAX',
};

export default MinMaxCalculationResultDetails;
